import React, { useEffect, useState } from 'react';
import Loading from '@/pages/intelligence/components/Loading';
import { history, useIntl } from 'umi';
import { Button } from 'tea-component';
import * as service from '@/pages/home/services/login';
import ErrorAlert from '../login/components/ErrorAlert';
import { getBasePath, storage } from '@/utils/utils';
import { isAllowDomain } from '@/pages/home/pages/login/_config/common';
import NoPermission from '@/pages/intelligence/assets/imgs/common/no-permission.png';
import './index.scss';
import { getRedirectUrlByEmail } from '@home/utils/userEmail';
import { IS_DEVICE_MOBILE, CALLBACK_URL } from '@/pages/home/_config/config';

interface MessageType {
  errType: string;
  errTip: string;
};

interface AlertInfoType {
  visible: boolean;
  message: string;
};


export default function ThirdPartyLogin() {
  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(true);
  // 页面状态提示
  const [errMessage, setErrMessage] = useState<MessageType>(
    {
      errType: '',
      errTip: '',
    }
  );

  // 错误告警提示

  const [alertInfo, setAlertInfo] = useState<AlertInfoType>(
    {
      visible: false,
      message: ''
    }
  );

  const { state, code, error }: any = history.location.query || {};
  const {
    clientId = '',
    companyId = '',
    redirect = '',
    identityProvider = 'identity provider',
  } = state ? JSON.parse(state as string) : {};

  // 拿到code请求login接口
  useEffect(() => {
    if (code) {
      onLogin(code, clientId, companyId, redirect);
    }else if(error && error === 'access_denied') {
      onClose();
    }
  }, []);

  // 请求login接口进行登录
  const onLogin = async (
    code: string,
    clientId: string,
    companyId: string,
    redirect: string,
  ) => {
    try {
      const res = await service.login({
        login_type: 'OIDC',
        client_id: clientId,
        code,
        ...(identityProvider === 'Google' && IS_DEVICE_MOBILE ? { callback_url: CALLBACK_URL } : {}),
      });
      const emailAddress = res?.email;
      // 非Google类型则存储当前companyId
      identityProvider !== 'Google' &&
        localStorage.setItem('companyId', companyId);
      // 针对谷歌以及okta 进行特殊标识
      storage.setItem('_dbh_login_type', {
        type: identityProvider === 'Google' ? 'Google' : 'OKTA',
      });
      // 重定向url符合域名检验则跳转过去
      if (typeof redirect === 'string' && isAllowDomain(redirect)) {
        window.location.replace(redirect);
      } else {
        // 检查邮箱后缀跳转
        if (identityProvider === 'Google' && emailAddress) {
          const redirectUrl = getRedirectUrlByEmail(emailAddress);
          if (redirectUrl) {
            window.location.replace(redirectUrl);
            return;
          }
        }
        window.location.replace(`${getBasePath()}/home`);
      }
    } catch (err: any) {
      console.log('err', err);
      onError(err);
      setLoading(false);
    }
  };

  // 获取用户信息失败，根据错误码提示用户
  const onError = (err?: any) => {
    if (err.code === 50002) {
      setErrMessage({
        errType: formatAlertMessage('dbh_login_google_email_fail'),
        errTip: formatAlertMessage('dbh_login_google_email_fail_tip'),
      });
    } else if (err.code === 50001) {
      setErrMessage({
        errType: formatAlertMessage('dbh_login_get_google_msg_fail', identityProvider),
        errTip: formatAlertMessage('dbh_login_get_google_msg_fail_tip'),
      });
    } else if (err.code === 20002) { // 数据库查询失败
      setErrMessage({
        errType: formatAlertMessage('dbh_login_database_query_fail'),
        errTip: formatAlertMessage('dbh_login_database_query_fail_tip'),
      });
    }else if (err.code === 50004) { // 新账号创建失败
      setErrMessage({
        errType: formatAlertMessage('dbh_login_account_creation_fail'),
        errTip: formatAlertMessage('dbh_login_account_creation_fail_tip'),
      });
    }else { // 其他
      setErrMessage({
        errType: formatAlertMessage('dbh_login_server_error_fail'),
        errTip: formatAlertMessage('dbh_login_server_error_fail_tip'),
      });
    }
    if (err.msg) {
      setAlertInfo({ visible: true, message: formatAlertMessage(err.msg) });
    }
  };

  const formatAlertMessage = (id: string, provider?: string) => {
    if (id && typeof id === 'string') {
      return provider
        ? formatMessage({ id, defaultMessage: id }, { provider })
        : formatMessage({ id, defaultMessage: id });
    }
    return id;
  };

  // 获取用户信息失败，用户返回登录页
  const onClose = () => {
    if (typeof redirect === 'string' && isAllowDomain(redirect)) {
      window.location.replace(`${getBasePath()}/login?redirect=${redirect}`);
    } else {
      window.location.replace(`${getBasePath()}/login`);
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="dbi-third-login-page-wrap">
          {/* 告警提示 */}
          { alertInfo.visible && (
            <ErrorAlert
              visible={alertInfo.visible}
              onClose={() =>
                setAlertInfo((old) => ({
                  visible: false,
                  message: old.message,
                }))
              }
              message={alertInfo.message}
            />
          )}
          <div className="dbi-third-login-page">
            <div className="dbi-third-login-box">
              <img src={NoPermission} className="dbi-third-login-box-left" />
              <div className="dbi-third-login-box-right">
                <div className="dbi-third-login-box-title">
                  {errMessage.errType}
                </div>
                <div className="dbi-third-login-box-desc">
                  {
                    <div className="dbi-third-login-box-describe">
                      {errMessage.errTip}
                      <span>{` ivyyfchen@tencent.com`}</span>
                    </div>
                  }
                </div>
              </div>
              <Button type="primary" onClick={onClose}>
                {formatMessage({ id: 'common_back' })}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
